import axios from 'axios';
import { env } from 'src/env';

export const isReviewMode = () => !!sessionStorage.getItem('review_co_id');
const tokenStorage = () => isReviewMode() ? sessionStorage : localStorage;

export const clearSession = () => {
  const storage = tokenStorage();
  ['accessToken', 'refreshToken', 'principal'].forEach(key => storage.removeItem(key));
  sessionStorage.removeItem('review_co_id');
  sessionStorage.removeItem('review_user');
};

export const saveSession = (result: any) => {
  if (!result?.access_token || !result?.refresh_token || !result?.principal) {
    throw new Error('로그인 응답이 올바르지 않습니다.');
  }
  tokenStorage().setItem('accessToken', result.access_token);
  tokenStorage().setItem('refreshToken', result.refresh_token);
  tokenStorage().setItem('principal', JSON.stringify(result.principal));
};

export const saveUserSession = (result: any) => {
  if (!result?.access_token || !result?.refresh_token || !result?.principal) {
    throw new Error('로그인 응답이 올바르지 않습니다.');
  }
  ['accessToken', 'refreshToken', 'principal', 'review_co_id', 'review_user']
    .forEach(key => sessionStorage.removeItem(key));
  saveSession(result);
};

export const getPrincipal = () => {
  try {
    if (!tokenStorage().getItem('accessToken') || !tokenStorage().getItem('refreshToken')) return null;
    return JSON.parse(tokenStorage().getItem('principal') || 'null');
  } catch {
    return null;
  }
};

export const getLoginPath = () => {
  const schema = sessionStorage.getItem('cust_schema');
  return schema && schema !== 'public' ? `/login?cust_schema=${encodeURIComponent(schema)}` : '/login';
};

export const publicApi = axios.create({ baseURL: env.REACT_APP_API_HOST, timeout: 10000 });
export const api = axios.create({ timeout: 10000 });
let refreshing: Promise<void> | null = null;

api.interceptors.request.use(config => {
  const review = sessionStorage.getItem('review_co_id');
  if (review) config.headers.set('X-Review-Co-Id', review);
  const token = tokenStorage().getItem('accessToken');
  if (token) config.headers.set('Authorization', `Bearer ${token}`);
  else config.headers.delete('Authorization');
  return config;
});

api.interceptors.response.use(response => response, async error => {
  const config = error.config;
  if (error.response?.status !== 401 || !config) return Promise.reject(error);
  const expire = () => {
    clearSession();
    window.location.replace(getLoginPath());
  };
  if (config._retried || !tokenStorage().getItem('refreshToken')) {
    expire();
    return Promise.reject(error);
  }
  config._retried = true;
  try {
    // A late 401 for the old access token can reuse an already refreshed session.
    if (config.headers.get('Authorization') === `Bearer ${tokenStorage().getItem('accessToken')}`) {
      if (!refreshing) {
        refreshing = publicApi.post('/api/auth/refresh', {
          refresh_token: tokenStorage().getItem('refreshToken'),
        }).then(({ data }) => saveSession(data.data.result)).finally(() => { refreshing = null; });
      }
      await refreshing;
    }
  } catch (refreshError: any) {
    if (refreshError.response?.status === 401) expire();
    return Promise.reject(refreshError);
  }
  return api.request(config);
});

export const exitReviewMode = () => {
  clearSession();
  window.close();
  window.location.replace(getLoginPath());
};
